import { useEffect, useState } from 'react';
import { Download, ShieldCheck } from 'lucide-react';
import { api } from './api.js';
import { Loading, Notice, formatStorageBytes } from './components.js';
import { t } from './i18n.js';
import { ConfirmIdentity, useConfirmationRequired } from './ConfirmIdentity.js';

interface Summary {
  available: boolean;
  reason?: string;
  mailbox?: string;
  messages?: number;
  folders?: number;
  contacts?: number;
  events?: number;
  bytes?: number;
}
export function MyData() {
  const [summary, setSummary] = useState<Summary>(),
    [error, setError] = useState('');
  const confirm = useConfirmationRequired();
  useEffect(() => {
    api<Summary>('/export/summary')
      .then(setSummary)
      .catch((e) => setError(e.message));
  }, []);
  return (
    <div className="my-data">
      <p className="rules-intro">
        {t(
          'Téléchargez une archive de vos données dans des formats standards : vos dossiers en mbox, votre carnet en vCard et votre agenda en iCalendar, avec un manifeste et l’empreinte de chaque fichier.',
        )}
      </p>
      {error && <Notice type="error">{error}</Notice>}
      {!summary && !error ? (
        <Loading label={t('Préparation du récapitulatif…')} />
      ) : summary && !summary.available ? (
        <Notice type="info">
          {t('L’export complet n’est pas disponible pour cette boîte pour le moment.')}
        </Notice>
      ) : (
        summary && (
          <>
            <dl className="my-data-summary">
              <div>
                <dt>{t('Messages')}</dt>
                <dd>{summary.messages}</dd>
              </div>
              <div>
                <dt>{t('Dossiers')}</dt>
                <dd>{summary.folders}</dd>
              </div>
              <div>
                <dt>{t('Contacts')}</dt>
                <dd>{summary.contacts}</dd>
              </div>
              <div>
                <dt>{t('Événements')}</dt>
                <dd>{summary.events}</dd>
              </div>
              <div>
                <dt>{t('Taille approximative')}</dt>
                <dd>{formatStorageBytes(summary.bytes ?? 0)}</dd>
              </div>
            </dl>
            {confirm ? (
              <ConfirmIdentity returnTo="data" />
            ) : (
              <a className="primary my-data-download" href="/v1/export/mailbox" download>
                <Download size={17} /> {t('Télécharger l’archive (.zip)')}
              </a>
            )}
            <p className="my-data-note">
              <ShieldCheck size={15} />
              {t(
                'L’export reste possible après une suspension commerciale, jusqu’à la suppression des données. Chaque export est inscrit au journal d’activité.',
              )}
            </p>
          </>
        )
      )}
    </div>
  );
}
